/**
 * Format a cent amount as a euro string with no thousands separator.
 *
 * Whole-euro inputs render without a fractional part:
 *   1900  -> "19"
 *   1950  -> "19.50"
 *   0     -> "0"
 *
 * The caller decides whether to wrap with "€" / "/mo" / etc. — this fn
 * returns digits only so it composes cleanly with surrounding copy.
 *
 * Rationale: pricing-ui's `formatPrice` outputs "$" + value; the Hub is in EUR.
 * We format here and prepend the symbol at the call site to stay consistent
 * with the existing `Dashboard` and `PricingSection` style.
 */
export function formatEuro(cents: number): string {
  if (!Number.isFinite(cents)) return "0";
  const euros = cents / 100;
  // Whole euros → no decimals; otherwise two-decimal precision.
  return Number.isInteger(euros) ? String(euros) : euros.toFixed(2);
}
